// import { CustomValidators } from 'ng2-validation/dist/index';
import { CustomValidators } from '../primeng_components/ng2-validation/index';

export const AlValidators = CustomValidators;
